// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="m22.41 19 .467-2.896h-2.918v-1.879c0-.792.407-1.564 1.714-1.564H23v-2.465S21.796 10 20.645 10c-2.403 0-3.974 1.387-3.974 3.898v2.206H14V19h2.671v7h3.288v-7h2.451z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Facebook);
